import * as React from "react";
import DataGrid, { Column } from "devextreme-react/data-grid";
import { Tooltip, Button } from "antd";

const DocumentsDetailComponent = (props: { dataFromParent: any; helpers: any }) => {
  const { dataFromParent, helpers } = props;
  const documentsFromTrade = dataFromParent.data.documentList;

  return (
    <DataGrid dataSource={documentsFromTrade} showBorders={true} columnAutoWidth={true}>
      <Column
        caption="#"
        alignment={"center"}
        width={"50px"}
        cellRender={params => {
          return (
            <>
              <Tooltip title="Download de documento">
                <Button
                  icon="download"
                  onClick={() => {
                    helpers.DownloadDocument(params.data, dataFromParent);
                  }}
                  style={{ backgroundColor: "#e5eefc" }}
                />
              </Tooltip>
            </>
          );
        }}
      />
      <Column caption="ID" alignment={"center"} dataField="id" dataType="number" width={"80px"} sortOrder={"desc"} />
      <Column caption="Categoria" alignment={"center"} dataField="category" dataType="string" />
      <Column caption="Descrição" alignment={"center"} dataField="description" dataType="string" />
      <Column caption="Data de Upload" alignment={"center"} dataField="uploadDate" dataType="date" format={"dd/MM/yyyy"} />
    </DataGrid>
  );
};

export default DocumentsDetailComponent;



// WEBPACK FOOTER //
// ./src/pages/monitor/upload/components/DocumentsDetailComponent.tsx